import { failedNotification } from "./notifications";
import { isValidationError } from "lib/validationError";
import { duplicateKeyFromAxios } from "./duplicateKeyError";

export const handleApiError = (error: any, customFallback?: string) => {

  if (error?.isSessionExpired) return;

  if (
    error?.message?.includes(
      "You forgot to wrap your component in <Auth0Provider>"
    )
  ) {
    failedNotification(
      "Error",
      "You are not authorized to perform this action."
    );
    return;
  }

  // New structured validation error (HTTP 400, type: "validation_error"):
  // `details` is a FieldIssue[] with display-ready `message`s. Surface them as
  // a single summary toast. Forms that want inline per-field errors should call
  // applyRestValidationError BEFORE falling back to this helper.
  const body = error?.response?.data;
  if (isValidationError(body)) {
    const message =
      body.details.map((d) => d.message).filter(Boolean).join("; ") ||
      body.message ||
      customFallback ||
      "Validation failed. Please check the form and try again.";
    failedNotification("Error", message);
    return;
  }

  // Mongo unique-index violation (E11000) — a generic, non-validation failure.
  // Surface a clean message instead of the raw "E11000 duplicate key ..." dump.
  const duplicate = duplicateKeyFromAxios(error);
  if (duplicate) {
    failedNotification("Error", duplicate.message);
    return;
  }

  const details = error?.response?.data?.details;

  const message =
    error?.response?.data?.details?.[0]?.errors?.join(", ") ||
    (
      Array.isArray(details)
        ? details.flatMap((d: any) => d?.errors || [])
        : Object.values(details || {}).map((d: any) => d?.message).filter(Boolean)
    ).join("; ") ||
    error?.response?.data?.error ||
    error?.response?.data?.message ||
    error?.message ||
    error?.toString() ||
    customFallback ||
    "Something went wrong. Please try again.";

  failedNotification("Error", message);
};
